import React, {useState} from 'react'
import globals from '../../globals.json';


function Drawer(props) {

  return (
    <div className={`Drawer ${props.beenOpened ? "opened" : "unopened"} ${props.open ? "open" : "closed"}`}>
      <div className="title-bar"
           onClick={props.setOpen}
           dangerouslySetInnerHTML={
             {__html: props.data.title}
           }></div>
      <div className={`drawer-body`}
           dangerouslySetInnerHTML={
             {__html: props.data.content}
           }
      ></div>
    </div>
  )
}

export default function Accordion(props) {
  const [openIndex, setOpenIndex] = useState(-1);
  const initialOpenState = props.data.drawers.map(() => {
    return false;
  })
  const [hasBeenOpened, setHasBeenOpened] = useState(initialOpenState);


  const openDrawer = (i) => {
    if (openIndex !== i) {
      let temp = hasBeenOpened;
      temp[i] = true;
      setHasBeenOpened(temp);
      setOpenIndex(i);
    } else {
      setOpenIndex(-1);
    }

  }


  const generateDrawers = () => {
    return props.data.drawers.map((el, i) => {
      return (
        <Drawer beenOpened={hasBeenOpened[i]} open={i === openIndex} setOpen={() => openDrawer(i)} data={el} key={i}/>
      )
    })
  }

  const checkComplete = () => {
    return hasBeenOpened.filter(el => !el).length === 0;
  }

  return (
    <div className={`Accordion ${props.data.class}`}>
      <h1>{props.data.headerText}</h1>
      <p>{props.data.bodyText}</p>
      <p className="instructions">{props.data.instructionText}</p>
      <div className="wrapper">
        {generateDrawers()}
      </div>

      {checkComplete() && <div className="next-button" onClick={props.onComplete}>{globals.nextButtonText}</div>}
    </div>
  )
}
